import request from '@/utils/request'

// 查询【请填写功能名称】列表
export function listLaw(query) {
  return request({
    url: '/web/system/law/list',
    method: 'get',
    params: query
  })
}

// 查询知识产权-法律法规政策列表
export function lawList(query) {
  return request({
    url: '/web/system/law/lawList',
    method: 'get',
    params: query
  })
}



// 查询知识产权-法律法规政策列表  医疗器械
export function lawListByYlqx(query) {
  return request({
    url: '/web/system/law/lawListByYlqx',
    method: 'get',
    params: query
  })
}
//查询法律法规详情信息
export function lawDetail(recid){
  return request({
    url: '/web/system/law/' + recid,
    method: 'get'
  })
}

//查询法律法规详情信息
export function lawDetailNew(query){
  return request({
    url: '/web/system/law/lawDetailNew',
    method: 'get',
    params:query
  })
}